<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-INSURANCE' : 'EDIT-INSURANCE') | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="editForm" class="k-form" style="margin-bottom:-30px;">
    <div class="row">
      <div class="col-6">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'INSURER' | translate}} {{requiredLabelInsurance('INSURER')}}
          </span>
          <kendo-dropdownlist #insurerControl id="insurer" class="w-100" [data]="insurersFiltered" [filterable]="true"
            [textField]="'name'" [valueField]="'id'" (filterChange)="handleInsurerFilter($event)"
            [itemDisabled]="insurerItemDisabled" [defaultItem]="currentDefaultInsuredItem" (close)="searchTerm=''"
            formControlName="insurer">
            <ng-template kendoDropDownListItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.name | highlight : searchTerm : currentDefaultInsuredItem.name }}">
              </span>
            </ng-template>
          </kendo-dropdownlist>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="insurer.hasError('required') && insurer.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURER')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-3">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'START-DATE' | translate}} {{requiredLabelInsurance('START_DATE')}}
          </span>
          <kendo-datepicker class="w-100" formControlName="startDate"></kendo-datepicker>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="startDate.hasError('required') && startDate.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('START_DATE')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-3">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'END-DATE' | translate}} {{requiredLabelInsurance('END_DATE')}}
          </span>
          <kendo-datepicker class="w-100" formControlName="endDate"></kendo-datepicker>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="endDate.hasError('required') && endDate.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('END_DATE')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'INSURED-FIRST-NAME' | translate}} {{requiredLabelInsurance('INSURED_FIRST_NAME')}}
          </span>
          <input id="insuredGivenName" kendoTextBox formControlName="insuredGivenName" maxlength="128" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="insuredGivenName.hasError('required') && insuredGivenName.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURED_FIRST_NAME')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'INSURED-LAST-NAME' | translate}} {{requiredLabelInsurance('INSURED_LAST_NAME')}}
          </span>
          <input id="insuredFamilyName" kendoTextBox formControlName="insuredFamilyName" maxlength="255" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="insuredFamilyName.hasError('required') && insuredFamilyName.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURED_LAST_NAME')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            <i class="fas fa-phone fa-fw"></i> {{'INSURER-BUSINESS-PHONE' | translate}}
            {{requiredLabelInsurance('INSURER_PHONE')}}
          </span>
          <kendo-maskedtextbox [mask]="phoneNumberMask" id="businessPhoneNumber" formControlName="businessPhoneNumber">
          </kendo-maskedtextbox>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="businessPhoneNumber.hasError('required') && businessPhoneNumber.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURER_PHONE')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'INSURANCE-MEMBER-ID' | translate}} {{requiredLabelInsurance('INSURANCE_MEMBER_ID')}}
          </span>
          <input id="insuranceMemberId" kendoTextBox formControlName="insuranceMemberId" maxlength="128" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="insuranceMemberId.hasError('required') && insuranceMemberId.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURANCE_MEMBER_ID')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'PLAN' | translate}} {{requiredLabelInsurance('PLAN')}}
          </span>
          <input id="plan" #planControl kendoTextBox formControlName="plan" maxlength="255" />
          <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="plan.hasError('required') && plan.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('PLAN')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'GROUP-ID' | translate}} {{requiredLabelInsurance('GROUP_ID')}}
          </span>
          <input id="groupId" kendoTextBox formControlName="groupId" maxlength="128" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="groupId.hasError('required') && groupId.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('GROUP_ID')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'POLICY-HOLDER' | translate}} {{requiredLabelInsurance('POLICY_HOLDER')}}
          </span>
          <input id="policyHolder" kendoTextBox formControlName="policyHolder" maxlength="128" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="policyHolder.hasError('required') && policyHolder.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('POLICY_HOLDER')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            {{'EMPLOYER' | translate}} {{requiredLabelInsurance('EMPLOYER')}}
          </span>
          <input id="employer" kendoTextBox formControlName="employer" maxlength="255" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="employer.hasError('required') && employer.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('EMPLOYER')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            <i (click)="openInsurerUrl()" [ngClass]="{'has-valid-url': isValidInsurerUrl()}"
              class="fas fa-link fa-fw"></i>
            {{'INSURER-WWW-URL' | translate}} {{requiredLabelInsurance('INSURER_WEBSITE')}}
          </span>
          <input id="insurerUrl" kendoTextBox formControlName="insurerUrl" maxlength="512" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="!isValidInsurerUrl() && insurerUrl.hasError('pattern') && insurerUrl.touched">
            {{'INVALID-WWW' | translate}}
          </div>
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="insurerUrl.hasError('required') && insurerUrl.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURER_WEBSITE')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
    </div>
    <div class="row">
      <!--Insurance Card File-->
      <div class="col-8">
        <label class="k-form-field">
          <span class="k-text-uppercase dark">
            <i class="fas fa-address-card fa-fw"></i> {{'INSURANCE-CARD' | translate}}
            {{requiredLabelInsurance('INSURANCE_CARD')}}
          </span>
          <input id="cardDocumentName" kendoTextBox formControlName="cardDocumentName" [readonly]="true" />
          <div class="k-tooltip k-tooltip-validation" role="alert"
            *ngIf="cardDocumentName.hasError('required') && cardDocumentName.touched">
            <span translate [translateParams]="{field: requiredTextInsurance('INSURANCE_CARD')}">{{ 'IS-REQUIRED'
              }}</span>
          </div>
        </label>
      </div>
      <div class="col-4" style="margin-top:34px;">
        <input class="d-none" type="file" (change)="onFileChanged($event)" #fileInput />
        <button kendoButton type="button" (click)="fileInput.click()">
          {{'SELECT-INSURANCE-CARD' | translate}}<i class="far fa-id-card"></i>
        </button>
        <i *ngIf="(isNewFileSelected || cardDocumentName.value !== null)" class="fas fa-trash-alt fa-lg ml-2"
          title="{{'DELETE-INSURANCE-CARD' | translate}}" (click)="deleteInsuranceCard()">
        </i>
      </div>
    </div>
  </form>
  <div class="mt-3">* {{'REQUIRED-FIELDS' | translate}}</div>
  <kendo-dialog-actions>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
      (click)="onSave($event)">{{
      'SAVE' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>